import React, { useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Message from './messages/Message';
import CommandeRecap from './CommandeRecap';
import CardCreneau from './cards/CardCreneau';
import CardCreneauMini from './cards/CardCreneauMini';
import CommuneAutocomplete from './forms/CommuneAutocomplete';
import GenericText from './forms/GenericText';
import ButtonNav from './button/ButtonNav';

export default function EtapeAdresseCreneau({ props }) {


	useEffect(() => {
		const element = document.getElementById('titreCreneaux');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}, [props.displayCreneaux]);

	return (
		<>
			<CommandeRecap />

			<Grid container direction="row" justifyContent="center">

				{props.displayCreneaux && props.creneauxList.length === 0 &&

					<>
						<Grid item xs={12}>
							<Typography id="titreCreneaux" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2, mt: 3 }}>
								Selection du créneau et du tarif
							</Typography>
						</Grid>

						<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
							<Message props={{
								type: "warning",
								titre: "Oups ... nous avons été dévalisés !",
								message: "Aucun créneau n'est disponible pour votre adresse dans les prochaines semaines.<br />De nouveaux créneaux sont créés chaque semaine en fonction des disponibilités de nos intervenants. Nous vous invitons à repasser d'ici quelques jours ou à contacter notre service client :",
								contact: true
							}} />
						</Grid>
					</>

				}

				{props.displayCreneaux && props.creneauxList.length > 0 &&

					<>

						{props.displayPrix &&
							<>
								<Grid item xs={12}>
									<Typography id="titreCreneaux" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2, mt: 3 }}>
										Selection du créneau et du tarif
									</Typography>
								</Grid>


								<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
									<Message props={{
										type: "success",
										titre: "Pourquoi les tarifs proposés sont-ils tous différents ?",
										message: "Nos prix s'adaptent en fonction du déplacement à réaliser par nos techniciens.<br />Lorsqu'un technicien a déjà un rendez-vous prévu proche du lieu de votre intervention vous bénéficiez du tarif le plus avantageux."
									}} />
								</Grid>
							</>
						}

						{props.creneauxBestPrice.id === props.creneauxBestDate.id

							? <Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
								<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2, mb: 3 }}>
									{props.displayPrix ? 'Meilleur tarif et date la plus proche' : 'Date la plus proche'}
								</Typography>
								<CardCreneau creneau={props.creneauxBestPrice} actionSelectCreneau={props.actionSelectCreneau} displayPrix={props.displayPrix} />
							</Grid>
							: <Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
								<Grid container direction="row" justifyContent="center">
									<Grid item xs={12} sm={12} md={6} p={1}>
										<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 26, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
											Meilleur tarif
										</Typography>
										<CardCreneauMini creneau={props.creneauxBestPrice} actionSelectCreneau={props.actionSelectCreneau} displayPrix={props.displayPrix} />
									</Grid>
									<Grid item xs={12} sm={12} md={6} p={1}>
										<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 26, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
											Date la plus proche
										</Typography>
										<CardCreneauMini creneau={props.creneauxBestDate} actionSelectCreneau={props.actionSelectCreneau} displayPrix={props.displayPrix} />
									</Grid>
								</Grid>
							</Grid>
						}

						<Grid item xs={12}>
							<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
								{props.displayPrix ? 'Tous les créneaux et tarifs' : 'Tous les créneaux'}
							</Typography>
						</Grid>

						<Grid item xs={12} mb={2} sx={{ display: 'flex', justifyContent: 'center' }}>
							{!props.isSortedTarifs &&
								<Box width={{ xs: '100%', sm: '60%', md: '60%', lg: '40%' }} mb={2} textAlign='center'>
									<ButtonNav props={{ text: 'Trier les créneaux par prix' }} action={props.handleSortTarifs} />
								</Box>
							}
							{!props.isSortedDates &&
								<Box width={{ xs: '100%', sm: '60%', md: '60%', lg: '40%' }} mb={2} textAlign='center'>
									<ButtonNav props={{ text: 'Trier les créneaux par date' }} action={props.handleSortDates} />
								</Box>
							}
						</Grid>

						<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
							{
								// Loop over creneaux list
								// Affichage et tri de la date la plus proche à la date la plus lointaine
								props.creneauxList.map(function(d) {
									return (
										<CardCreneau key={d.id} creneau={d} actionSelectCreneau={props.actionSelectCreneau} displayPrix={props.displayPrix} />
									)
								})
							}
						</Grid>
					</>
				}

				<Grid item xs={12}>
					<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
						L'adresse de mon intervention
					</Typography>
				</Grid>

				<Grid item xs={12} sm={12} md={11} lg={11} xl={8}>
					<Grid container spacing={2}>

						<Message props={{ type: 'info', message: 'Saisissez l\'adresse du lieu de l\'intervention pour afficher la liste des créneaux et tarifs disponibles.' }} />

						<Grid item xs={12}>
							<CommuneAutocomplete id="commune" required={true} />
						</Grid>

						<Grid item xs={12}>
							<GenericText
								required={true}
								id="adresse"
								label="Adresse de l'intervention (Numéro et voie)" />
						</Grid>

						<Grid item xs={12}>
							<GenericText
								id="adresseComplement"
								label="Complément d'adresse (Résidence, Bâtiment, Etage, ...)" />
						</Grid>

						{!props.validation.isValid &&
							<Message props={{ type: 'error', message: props.validation.messageErreur }} />
						}
						{props.validation.isValid && props.error &&
							<Message props={{
								type: 'error',
								titre: 'Oups ... Nous rencontrons un problème technique !',
								message: '<p>Si le problème persiste vous pouvez contacter notre service client :</p>',
								contact: true
							}} />
						}
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}